<template>
  <b-modal
    v-model="internalFields.open"
    v-if="internalFields.open"
    no-close-on-backdrop
    centered
    :busy="loading"
    v-bind="$attrs"
    v-on="$listeners"
    @close="handleModalClose()"
    @hidden="handleModalClose()"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <slot />
      </b-col>
    </b-row>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]="scope">
      <slot :name="slotName" v-bind="scope" />
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'BaseModal',
  emits: ['update:open', 'closed'],
  model: {
    prop: 'open',
    event: 'update:open',
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    open() {
      this.internalFields.open = this.open;
    },
  },
  data() {
    return {
      internalFields: {
        open: false,
      },
    };
  },
  methods: {
    handleModalClose() {
      this.internalFields.open = false;
      this.$emit('closed');
      this.$emit('update:open', this.internalFields.open);
    },
  },
};
</script>